import type { Components, Theme } from "@mui/material/styles";

export const MuiTableRow: Components<Theme>["MuiTableRow"] = {
  styleOverrides: {
    root: {
      // enable full-row anchor tags
      display: "table-row",
      textDecoration: "none",
    },
  },
};
